import React from 'react';
import { useSelector } from 'react-redux';

import ListItem from 'components/ListItem';
import { AppState } from 'services/types';
import { FertilizerProductId } from 'services/fertilizerProducts/types';
import { FertilizerEntityIds } from 'services/fertilizerEvents/types';
import { makeSelectTotalArea } from './selectors';

export interface Props {
    productId: FertilizerProductId;
    entityIds: FertilizerEntityIds;
}

export default function FertilizerEventTotalAreaListItem(
    props: Props
): React.ReactElement {
    const totalArea = useSelector((state: AppState) =>
        makeSelectTotalArea()(state, props)
    );

    return <ListItem value={`${totalArea} Ha`} description="Total area" />;
}
